export {
  whyZapierLink,
  exploreLink,
  resourcesLink,
  teamsLink,
  pricingLink,
  dashboardLink,
  zapsLink,
  myAppsLink,
  historyLink,
  helpLink,
  usageLink,
  moveZapsLink,
  settingsLink,
  logOutLink,
  transferLink,
  UniversalSidebarLinks,
  UniversalTopbarLinks,
  AccountsMenuLinks,
} from './links';
export type { UniversalNavLinkType } from './links';

// Account action paths
export const signupPath = '/sign-up/';
export const loginPath = '/app/login';

// Utility constants
export const skipLinkHref = '#mainContent';
export const UNIVERSAL_NAV_ZINDEX = 950;
export const UNIVERSAL_NAV_SUBMENU_ZINDEX = UNIVERSAL_NAV_ZINDEX + 1;
export const UNIVERSAL_TOPBAR_HEIGHT = 70;
export const UNIVERSAL_TOPBAR_CONDENSED_HEIGHT = 60;
export const UNIVERSAL_SIDEBAR_WIDTH = 300;
export const UNIVERSAL_SIDEBAR_COLLAPSED_WIDTH = 70;
